export const generateIdOrKey = () => {
    return Math.random().toString(20)
}

export const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
}